import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
  makeRequest(
    'post',
    `/api/participations/${participationID}/remove_reward`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/removePoint.js